/**
 * Moet exact overeenkomen met TURNSTILE_EXPECTED_ACTION in
 * functions/services/turnstileService.ts. Bewust gedupliceerd in plaats van
 * gedeeld, omdat de publieke bundel geen code uit functions/ mag bevatten.
 */
export const TURNSTILE_EXPECTED_ACTION_PLACEHOLDER = "dmm_booking_request";
